import {
  categoryTaxonomy,
  formatCategory,
  getAllCategoryFilterValues,
  getCanonicalCategory,
  getCategoryDefinition,
  getCategoryFilterValues,
  getCategoryTreeFilterValues,
} from './category-taxonomy';
import productCategoryDecisions from '@/data/product-category-decisions.json';
import reviewedProductCategories from '@/data/product-category-reviewed.json';
import { Prisma } from '@prisma/client';

export function hasReviewedProductCategoryDecision(slug: string) {
  return (reviewedProductCategories as string[]).includes(slug);
}

export const consumerProductSlugs = [
  'canvas',
  'map-poster',
  'ingelijst-canvas',
  'mok',
  'acrylglas-print',
  'appelsap-200ml',
  'appel-vlierbessen-sap-200ml',
  'aluminium-fles-met-karabijnhaak-400ml',
  'aluminium-print',
  'hd-metal-print',
  'dibond-print',
  'ingelijste-poster',
  'passe-partout-print',
  'fototegel',
  'fotobehang',
  'behangrol',
  'foto-op-poster',
  'behangcirkel',
  'airtex',
  'tuinposter',
  'houten-textielframe',
  'akoestisch-textielframe',
  'akoestisch-plafondframe',
  'peesdoek',
  'fotopaneel-met-baklijst',
  'textielposter',
  'wandkleed',
  'deurmat-met-rand',
  'vloerbeschermer',
  'handdoek-en-strandlaken',
  'badjas',
  'bierkrat',
  'binnenkleed',
  'fleecedeken',
  'picknickkleed',
  'badmat',
  'draagtas',
  'sierkussen',
  'buitenkussen',
  'foto-hanger',
  'multi-fotolijst',
  'instagram-fotolijst',
  'kurkbord-met-lijst',
  'schort',
  'huisdierpenning',
  'gepersonaliseerd-blik',
  'americano-espresso-250ml',
  'plantenpot',
  'plastic-sleutelhanger',
  'patch',
  'tijdelijke-tattoo',
  'slabbetje',
  'textieltransfer',
  'legpuzzel',
  'zitzak',
  'inductie-beschermer',
  'keuken-spatwand',
  'acousticpro-panelen',
  'akoestische-hexagon-panelen',
  'akoestische-roomdivider',
  'akoestisch-bureauscherm',
  'akoestisch-wandframe',
  'vinylsticker',
  'muursticker',
  'meubelsticker',
  'stickers-klein',
  'stickers-op-rol',
  'stickervellen',
  'verzendetiketten',
  'raamstickers',
  'dubbelzijdige-raamstickers',
  'vloerstickers',
  'snijfolie',
  // Consumentenvariant van snijfolie: dezelfde Print.com-sku
  // (`vinyl-cut-letters`), maar per stuk en op eigen formaat in plaats van de
  // groothandelsrol. Zie prisma/handmatig/2026-08-01-plakletters-product.ts.
  'plakletters',
  'biond-bio-print-folie',
  'one-way-vision-folie',
  'doming-stickers',
  'spandoek',
  'lichtbak',
  'lichtbakplaat',
  'kliklijsten',
  'naambord-voordeur',
  'stoepbord-met-watertank',
  'bewegwijzeringsbord',
  'visitekaartjes',
  'ansichtkaarten',
  'posters',
  'abri-poster',
  'lichtbakposter',
  'magneetposter',
  'neonposter',
  'neon-print',
  'poster-met-folie',
  'stoepbordposter',
  'zelfklevende-poster',
  'watervaste-poster',
  'flyers',
  'folder',
  'folders',
  'briefpapier',
  'huisstijl-briefpapier',
  'huisstijl-enveloppen',
  'menukaarten',
  'presentatiemappen',
  'brochure-gelijmd',
  'brochure-wire-o',
  'brochure-squarefold',
  'boekenleggers',
  'compliment-cards',
  'luxe-visitekaartjes',
  'bouwtekening',
  'keramische-tegels',
  'ceramische-tegels',
  'premium-stoepbord',
  'vlag',
  'vlaggen',
  'beachflag',
  'beachflag-mast',
  'beachflags',
  'baniervlaggen',
  'bouwhekdoeken',
  'dranghekdoeken',
  'blind-frame-spandoeken',
  'blind-spandoekframe',
  'a-borden',
  'kleine-a-borden',
  'gevelvlag',
  'mastvlag',
  'roll-up-banner',
  'rollup-banner',
  'banier',
  'beurswand',
  'display',
  'stoepbord',
  'gevelbanner',
  'gevelbord',
  'raamsticker',
  'makelaarsbord',
  'reclamebord',
  'sportveldbord',
  'plaatmateriaal',
  'forex',
  'dibond',
  'forexre',
  're-board',
  'plexiglas',
  'hpl-trespa',
  'kanaalplaat-polyprop',
  'displaykarton',
  'foamboard',
  'dibond-butler-finish',
  'dispa',
  'flexibel-pvc',
  'forex-black',
  'golfkarton',
  'pet-vilt',
  'polystyreen',
  'amerikaanse-vouwdozen',
  'geschenkdozen-met-deksel',
  'hamburgerverpakkingen',
  'banderollen',
  'papieren-onderzetters',
  'airlaid-servetten',
  'celstof-servetten',
  'servet-bamboe',
  'foodboxen',
  'bouwtekeningen',
  'notitieblokken',
  'stempels',
  'consumptiebonnen',
  'kraskaarten',
  'lotenboekjes',
  'kaarten-met-envelop',
  'groeipapier-kaarten',
  'holografische-stickers',
  'fluorescerende-stickers',
  'frontlit-banners',
  'hekwerkbanners',
  'tickets',
  'tabbladen',
  'tafelkaart',
  'tentkaart-staand',
  'textielstickers',
  'spandoek-eigen-vorm',
  'triaflex-spandoek',
  'textieldoek',
  'tafelkleed',
  'showkaarten',
  'tyvek-polsbandjes',
  'plastic-polsbandjes',
  'vinyl-polsbandjes',
  'koelkastmagneten',
  'papieren-tassen',
  'gevouwen-plattegronden',
  'bureaukalender',
  'wandkalender',
  'bureau-maandkalender',
  'adventskalender',
  'waaierkaarten',
  'buttons',
  'bestekzakjes',
  'placemats',
  'entreematten',
  'vloervinyl',
  'statische-raamfolie',
  'magneetfolie',
  'wandcirkels',
  'plafondhanger',
  'folderhouder',
  'herbruikbare-bekers',
  'draagtrays',
  'foto-op-karton',
  'foto-op-forex',
  'kartonnen-fotolijst',
  'zipper-banner',
  'display-kubus',
  'stretch-tafelhoes',
  'chromaluxe-metal-print',
  'papieren-tassen-gedraaid-koord',
  'luxe-papieren-tassen',
  'herbruikbare-bekers-all-over',
  'fotopanelen',
  'foto-op-stretchframe',
  'hd-foto-achter-plexiglas',
  'stapelbare-pos-displays',
  'bezorgdisplays',
  'totem-displays',
  'tuinborden',
  'pop-up-wand',
  'mini-magazines',
  'kranten',
  'kaartsets',
  'vlaggenlijnen',
  'stokvlaggetjes',
  'prikkervlaggetjes',
  'brievenbusdozen-met-klep',
  'luxe-tassen-zeefdruk',
  'gift-bags',
  'geweven-polsbandjes',
  'deurhangers',
  'pop-up-kaarten',
  'bedrukt-lint',
  'bedrukte-tape',
  'tafelvlaggen',
  'wobblers',
  'schapstrips',
  'productdisplays',
  'luchtkussen-enveloppen',
  'ringbandvulling',
  'kubuskalenders',
  'textielframe',
  'telefoonhoesje',
  'airpods-hoesje-met-all-over-print-681',
  'airpods-hoesje-met-print-605',
  'muismat',
  'laptop-sleeve',
  'fotoboek',
  'magazine',
  'magazine-geniet',
  'canvas-ophangsysteem',
  'blind-ophangsysteem',
  'baklijst-voor-plaatmateriaal',
  'ophangplaat',
  'a-bord-paneelclips',
  'acrylox-stalenkettingen',
  'kartonnen-standaarden',
  'naambordhouders',
  'panel-base',
  'plafond-magneet',
  'sportveldbeugel',
  'systeemplafond-clip',
  'tafelstandaards',
  'zelfklevende-magneten',
  'zuignap-met-moer',
  'ophangoog',
  'verstelbare-ophangkabel',
  'posterklem',
  'rakel-met-vilten-rand',
  'flexxs-lijm',
  'spanner-met-spinhaak',
  'stormfix-spanner',
  'tiewrap',
  'karabijnhaak',
  'plafondhaak',
  'zuignap-met-haak',
  'mini-standaardjes',
  'plakhanger',
  'afstandhouder',
  'nylon-afstandhouder',
  'hexagon-afstandhouder',
  'lijm-voor-afstandhouder',
  'barok-standaard',
  'bamboe-standaard',
  'bamboe-prikker',
  'aansteker-basic',
  'aansteker-met-flesopener',
  'basic-pet',
  'basic-schort',
  'beker-rvs-conisch-luxe',
  'baby-romper-met-print-512',
  'baby-romper-met-print-843',
  'bikinibroekje-met-all-over-print-468',
  'bikinibroekje-met-all-over-print-669',
  'bikini-met-all-over-print-870',
  'bikinitop-met-all-over-print-871',
  'aftersun-mousse',
  'multiplex',
  'structex',
  'samba',
  'percal',
  'velours',
  'vloerzeil',
  'pc-canvas',
  'pvc-lichtbakdoek',
  'zwaar-bannerdoek',
  'vlagdoek',
] as const;

export const consumerCategories = [
  ...categoryTaxonomy.map((category) => category.slug),
] as const;

export const heroProductSlugs = [
  'canvas',
  'mok',
  'ingelijste-poster',
  'acrylglas-print',
  'fototegel',
  'fotobehang',
  'foto-op-poster',
  'tuinposter',
  'vinylsticker',
] as const;

const productCategoryAssignments: Record<string, string[]> = {
  'inductie-beschermer': ['keuken-interieur', 'indoor-interior', 'home-living'],
  'keuken-spatwand': ['keuken-interieur', 'indoor-interior', 'home-living', 'plaatmateriaal', 'aluminium-dibond'],
  'acryl-fotoblok': ['foto-cadeaus', 'home-living', 'wanddecoratie', 'fotoprints'],
  'keramische-tegels': ['fototegels', 'keuken-interieur', 'wanddecoratie', 'home-living'],
  'ceramische-tegels': ['fototegels', 'keuken-interieur', 'wanddecoratie', 'home-living'],
  fototegel: ['fototegels', 'keuken-interieur', 'wanddecoratie', 'home-living'],
  fototegels: ['fototegels', 'keuken-interieur', 'wanddecoratie', 'home-living'],
  'deurmat-met-rand': ['deurmatten', 'floor-decoration', 'indoor-interior', 'home-living'],
  badmat: ['floor-decoration', 'home-living', 'textiel-cadeaus'],
  binnenkleed: ['floor-decoration', 'indoor-interior', 'home-living', 'textiel-cadeaus'],
  vloerbeschermer: ['vloerbescherming', 'floor-decoration', 'indoor-interior'],
  wandkleed: ['home-living', 'indoor-interior', 'wanddecoratie'],
  multiplex: ['plaatmateriaal', 'wanddecoratie'],
  'gerecycled-kunststof-paneel': ['plaatmateriaal'],
  structex: ['textielmaterialen', 'textielframes-doeken', 'indoor-interior'],
  samba: ['textielmaterialen', 'textielframes-doeken', 'binnenreclame'],
  percal: ['textielmaterialen', 'textiel-cadeaus'],
  velours: ['textielmaterialen', 'textiel-cadeaus'],
  kendal: ['textielmaterialen', 'textiel-cadeaus'],
  vloerzeil: ['floor-decoration', 'vloerbescherming'],
  'pc-canvas': ['canvas', 'wanddecoratie'],
  'pvc-lichtbakdoek': ['textielmaterialen', 'lichtreclame', 'binnenreclame'],
  'zwaar-bannerdoek': ['spandoeken-banners', 'outdoor-advertising'],
  vlagdoek: ['textielmaterialen', 'vlaggen'],
  textielposter: ['textielmaterialen', 'indoor-interior', 'wanddecoratie', 'textielframes-doeken'],
  dekostof: ['textielmaterialen', 'textielframes-doeken', 'indoor-interior', 'beurs-evenement'],
  textielframe: ['textielframes-doeken', 'indoor-interior', 'wanddecoratie'],
  peesdoek: ['textielframes-doeken', 'textielmaterialen', 'indoor-interior', 'wanddecoratie'],
  'houten-textielframe': ['textielframes-doeken', 'indoor-interior', 'wanddecoratie'],
  'akoestisch-textielframe': ['akoestiek', 'textielframes-doeken', 'indoor-interior', 'wanddecoratie'],
  'akoestisch-plafondframe': ['akoestiek', 'textielframes-doeken', 'indoor-interior'],
  'acousticpro-panelen': ['akoestiek', 'indoor-interior', 'wanddecoratie'],
  'akoestische-hexagon-panelen': ['akoestiek', 'indoor-interior', 'wanddecoratie'],
  'akoestische-roomdivider': ['akoestiek', 'indoor-interior', 'textielframes-doeken'],
  'akoestisch-bureauscherm': ['akoestiek', 'indoor-interior', 'kantoor-promotie'],
  'akoestisch-wandframe': ['akoestiek', 'textielframes-doeken', 'indoor-interior', 'wanddecoratie'],
  'sierkussen': ['kussens', 'home-living', 'textiel-cadeaus'],
  'buitenkussen': ['kussens', 'home-living', 'textiel-cadeaus', 'outdoor-living'],
  'fleecedeken': ['dekens-handdoeken', 'home-living', 'textiel-cadeaus'],
  'picknickkleed': ['dekens-handdoeken', 'home-living', 'textiel-cadeaus', 'outdoor-living'],
  'handdoek-en-strandlaken': ['dekens-handdoeken', 'home-living', 'textiel-cadeaus'],
  badjas: ['textiel-cadeaus', 'home-living', 'relatiegeschenken'],
  draagtas: ['textiel-cadeaus', 'kleding'],
  'tote-bag': ['tassen', 'textiel-cadeaus', 'kleding'],
  'roll-up-banner': ['roll-up-banners', 'beurs-evenement', 'displays-pos', 'outdoor-advertising'],
  banier: ['gevelvlaggen', 'vlaggen', 'spandoeken-banners', 'outdoor-advertising', 'beurs-evenement'],
  gevelvlag: ['gevelvlaggen', 'vlaggen', 'gevel-voertuig', 'outdoor-advertising'],
  spandoek: ['spandoeken-banners', 'outdoor-advertising', 'beurs-evenement'],
  bouwhekdoeken: ['spandoeken-banners', 'outdoor-advertising', 'beurs-evenement'],
  dranghekdoeken: ['spandoeken-banners', 'outdoor-advertising', 'beurs-evenement'],
  'blind-frame-spandoeken': ['spandoeken-banners', 'outdoor-advertising'],
  'blind-spandoekframe': ['spandoeken-banners', 'outdoor-advertising'],
  'a-borden': ['stoepborden', 'outdoor-advertising', 'displays-pos'],
  'kleine-a-borden': ['stoepborden', 'outdoor-advertising', 'displays-pos'],
  'beachflag-mast': ['beachflags', 'accessoires', 'vlaggen'],
  'beachflag-tas': ['beachflags', 'accessoires', 'vlaggen'],
  baniervlaggen: ['gevelvlaggen', 'vlaggen', 'outdoor-advertising'],
  lichtbak: ['lichtreclame', 'outdoor-advertising', 'gevel-voertuig', 'binnenreclame'],
  lichtbakplaat: ['lichtreclame', 'outdoor-advertising', 'gevel-voertuig', 'plaatmateriaal'],
  kliklijsten: ['standaards-houders', 'accessoires', 'displays-pos', 'posters'],
  'naambord-voordeur': ['naamborden-huisnummers', 'bewegwijzering-borden', 'outdoor-advertising', 'plaatmateriaal', 'home-living'],
  'stoepbord-met-watertank': ['stoepborden', 'outdoor-advertising', 'displays-pos'],
  'premium-stoepbord': ['stoepborden', 'outdoor-advertising', 'displays-pos'],
  'stoepbord-a-bord-klein-a3a4': ['stoepborden', 'displays-pos', 'indoor-interior'],
  bewegwijzeringsbord: ['bewegwijzering-borden', 'outdoor-advertising', 'gevel-voertuig', 'displays-pos'],
  sportveldbord: ['bewegwijzering-borden', 'outdoor-advertising', 'gevel-voertuig', 'plaatmateriaal'],
  gevelbord: ['bewegwijzering-borden', 'outdoor-advertising', 'gevel-voertuig', 'plaatmateriaal', 'plaat-forex'],
  reclamebord: ['bewegwijzering-borden', 'outdoor-advertising', 'gevel-voertuig', 'plaatmateriaal', 'plaat-forex'],
  plaatmateriaal: ['plaatmateriaal'],
  forex: ['plaat-forex', 'plaatmateriaal'],
  forexre: ['plaat-forex', 'plaatmateriaal'],
  'forex-black': ['plaat-forex', 'plaatmateriaal'],
  dibond: ['plaat-dibond', 'plaatmateriaal', 'aluminium-dibond'],
  'dibond-butler-finish': ['plaat-dibond', 'plaatmateriaal', 'aluminium-dibond'],
  plexiglas: ['plexiglas-acryl', 'plaatmateriaal', 'wanddecoratie'],
  'hpl-trespa': ['plaatmateriaal'],
  'kanaalplaat-polyprop': ['plaat-karton-board', 'plaatmateriaal'],
  displaykarton: ['plaat-karton-board', 'plaatmateriaal'],
  foamboard: ['plaat-karton-board', 'plaatmateriaal'],
  're-board': ['plaat-karton-board', 'plaatmateriaal'],
  dispa: ['plaat-karton-board', 'plaatmateriaal'],
  'flexibel-pvc': ['plaat-forex', 'plaatmateriaal'],
  golfkarton: ['plaat-karton-board', 'plaatmateriaal'],
  'pet-vilt': ['plaatmateriaal', 'indoor-interior'],
  polystyreen: ['plaatmateriaal'],
  'amerikaanse-vouwdozen': ['verpakkingen', 'paper-print'],
  'geschenkdozen-met-deksel': ['verpakkingen', 'relatiegeschenken'],
  hamburgerverpakkingen: ['verpakkingen', 'horeca-menu'],
  banderollen: ['verpakkingen', 'paper-print'],
  'papieren-onderzetters': ['horeca-menu', 'paper-print', 'relatiegeschenken'],
  'airlaid-servetten': ['horeca-menu', 'paper-print'],
  'celstof-servetten': ['horeca-menu', 'paper-print'],
  'servet-bamboe': ['horeca-menu', 'paper-print'],
  foodboxen: ['verpakkingen', 'horeca-menu'],
  'a-bord-paneelclips': ['banner-accessoires', 'accessoires', 'stoepborden'],
  'acrylox-stalenkettingen': ['materiaal-samples', 'accessoires'],
  'kartonnen-standaarden': ['standaards-houders', 'accessoires', 'displays-pos'],
  naambordhouders: ['afstandhouders', 'accessoires', 'bewegwijzering-borden'],
  'panel-base': ['standaards-houders', 'accessoires', 'displays-pos'],
  'plafond-magneet': ['ophangsystemen', 'accessoires'],
  sportveldbeugel: ['banner-accessoires', 'accessoires', 'bewegwijzering-borden'],
  'systeemplafond-clip': ['ophangsystemen', 'accessoires'],
  tafelstandaards: ['standaards-houders', 'accessoires', 'displays-pos'],
  'zelfklevende-magneten': ['ophangsystemen', 'accessoires'],
  'zuignap-met-moer': ['banner-accessoires', 'accessoires'],
  banieruithouders: ['banner-accessoires', 'accessoires', 'standaards-houders'],
  vinylsticker: ['vinylstickers', 'stickers-tapes', 'gevel-voertuig'],
  muursticker: ['muurstickers', 'stickers-tapes', 'binnenreclame', 'indoor-interior'],
  meubelsticker: ['muurstickers', 'stickers-tapes', 'indoor-interior', 'home-living'],
  'stickers-klein': ['vinylstickers', 'stickers-tapes'],
  'stickers-op-rol': ['labels-etiketten', 'stickers-tapes'],
  stickervellen: ['labels-etiketten', 'stickers-tapes'],
  verzendetiketten: ['labels-etiketten', 'stickers-tapes', 'verpakkingen'],
  raamstickers: ['stickers-folies', 'stickers-tapes', 'gevel-voertuig'],
  'dubbelzijdige-raamstickers': ['stickers-folies', 'stickers-tapes', 'gevel-voertuig'],
  vloerstickers: ['vloerbescherming', 'floor-decoration', 'stickers-tapes'],
  snijfolie: ['stickers-folies', 'stickers-tapes', 'gevel-voertuig'],
  plakletters: ['stickers-folies', 'stickers-tapes', 'gevel-voertuig', 'binnenreclame'],
  'biond-bio-print-folie': ['stickers-folies', 'stickers-tapes'],
  'one-way-vision-folie': ['stickers-folies', 'stickers-tapes', 'gevel-voertuig'],
  'doming-stickers': ['vinylstickers', 'stickers-tapes', 'relatiegeschenken'],
  folders: ['folders-brochures', 'paper-print'],
  folder: ['folders-brochures', 'paper-print'],
  briefpapier: ['briefpapier-enveloppen', 'paper-print', 'kantoor-promotie'],
  'huisstijl-briefpapier': ['briefpapier-enveloppen', 'paper-print', 'kantoor-promotie'],
  'huisstijl-enveloppen': ['briefpapier-enveloppen', 'paper-print', 'kantoor-promotie'],
  menukaarten: ['horeca-menu', 'paper-print'],
  presentatiemappen: ['folders-brochures', 'paper-print', 'kantoor-promotie'],
  'brochure-gelijmd': ['folders-brochures', 'boeken-magazines', 'paper-print'],
  'brochure-wire-o': ['folders-brochures', 'boeken-magazines', 'paper-print'],
  'brochure-squarefold': ['folders-brochures', 'boeken-magazines', 'paper-print'],
  boekenleggers: ['paper-print', 'relatiegeschenken'],
  'compliment-cards': ['paper-print', 'kantoor-promotie'],
  'luxe-visitekaartjes': ['visitekaartjes', 'paper-print'],
  flyers: ['flyers', 'paper-print'],
  visitekaartjes: ['visitekaartjes', 'paper-print'],
  bouwtekening: ['bouwtekeningen', 'paper-print'],
  poster: ['posters', 'paper-print'],
  posters: ['posters', 'paper-print'],
  'abri-poster': ['posters', 'outdoor-advertising', 'paper-print'],
  lichtbakposter: ['posters', 'lichtreclame', 'outdoor-advertising', 'paper-print'],
  magneetposter: ['posters', 'stickers-folies', 'paper-print'],
  neonposter: ['posters', 'paper-print'],
  'neon-print': ['plaatmateriaal', 'stickers-folies', 'posters', 'binnenreclame'],
  'poster-met-folie': ['posters', 'paper-print'],
  stoepbordposter: ['posters', 'stoepborden', 'outdoor-advertising', 'paper-print'],
  'zelfklevende-poster': ['posters', 'stickers-tapes', 'paper-print'],
  'watervaste-poster': ['posters', 'outdoor-advertising', 'paper-print'],
  'foto-op-poster': ['posters', 'paper-print', 'fotoprints', 'wanddecoratie', 'indoor-interior'],
  'acrylglas-print': ['plexiglas-acryl', 'wanddecoratie'],
  'aluminium-print': ['aluminium-dibond', 'wanddecoratie'],
  'hd-metal-print': ['aluminium-dibond', 'wanddecoratie'],
  'dibond-print': ['aluminium-dibond', 'wanddecoratie'],
  'forex-print': ['plaat-forex', 'wanddecoratie', 'plaatmateriaal'],
  fotolijst: ['ingelijste-prints', 'wanddecoratie'],
  'multi-fotolijst': ['ingelijste-prints', 'wanddecoratie'],
  'instagram-fotolijst': ['ingelijste-prints', 'wanddecoratie', 'fotoprints'],
  'kurkbord-met-lijst': ['ingelijste-prints', 'wanddecoratie', 'kantoor-promotie'],
  'ingelijste-poster': ['posters', 'paper-print', 'ingelijste-prints', 'wanddecoratie', 'fotoprints'],
  'passe-partout-print': ['ingelijste-prints', 'wanddecoratie', 'fotoprints'],
  'behangcirkel': ['behang-wandbekleding', 'indoor-interior'],
  'behangrol': ['behang-wandbekleding', 'indoor-interior'],
  fotobehang: ['behang-wandbekleding', 'indoor-interior'],
  waterfles: ['glaswerk-drinkflessen', 'drinkwaren', 'relatiegeschenken'],
  telefoonhoesje: ['telefoonhoesjes', 'technologie'],
  schort: ['werkkleding-horeca', 'textiel-cadeaus', 'home-living'],
  huisdierpenning: ['foto-cadeaus', 'relatiegeschenken', 'sleutelhangers-keycords'],
  'americano-espresso-250ml': ['snoep-eten-drinken', 'relatiegeschenken', 'glaswerk-drinkflessen'],
  'gepersonaliseerd-blik': ['foto-cadeaus', 'home-living', 'relatiegeschenken'],
  plantenpot: ['home-living', 'foto-cadeaus', 'keuken-interieur'],
  'plastic-sleutelhanger': ['sleutelhangers-keycords', 'relatiegeschenken', 'foto-cadeaus'],
  patch: ['textiel-cadeaus', 'kleding', 'relatiegeschenken'],
  'tijdelijke-tattoo': ['stickers-tapes', 'relatiegeschenken', 'sport-spel'],
  slabbetje: ['textiel-cadeaus', 'kleding', 'foto-cadeaus'],
  textieltransfer: ['kleding', 'textiel-cadeaus', 'shirts-tops'],
  legpuzzel: ['spellen-puzzels', 'sport-spel', 'foto-cadeaus'],
  'barok-standaard': ['standaards-houders', 'accessoires'],
};

const categoryRuleAssignments: Array<{
  categories: string[];
  categoriesMatch?: string[];
  slugIncludes?: string[];
  slugStartsWith?: string[];
}> = [
  { categories: ['relatiegeschenken'], categoriesMatch: ['gifts-merchandise-promotional', 'gadgets', 'summer-goodies'] },
  { categories: ['textiel-cadeaus', 'kleding'], categoriesMatch: ['clothing-textile'] },
  { categories: ['displays-pos', 'binnenreclame'], categoriesMatch: ['displays-pos-material'] },
  { categories: ['home-living', 'indoor-interior'], categoriesMatch: ['indoor-furniture'] },
  { categories: ['outdoor-advertising', 'plaatmateriaal'], categoriesMatch: ['large-format-sign'] },
  { categories: ['pennen-schrijfwaren', 'relatiegeschenken'], slugStartsWith: ['pen-', 'potlood', 'kleurpotlood', 'tekstmarker', 'timmermanspotlood', 'liniaal'] },
  { categories: ['sleutelhangers-keycords', 'relatiegeschenken'], slugIncludes: ['sleutelhanger', 'keycord'] },
  { categories: ['paraplus-regen', 'relatiegeschenken'], slugIncludes: ['paraplu', 'golfparaplu', 'regenponcho'] },
  { categories: ['snoep-eten-drinken', 'relatiegeschenken'], categoriesMatch: ['chocolate', 'easter'], slugIncludes: ['chocolade', 'mentos', 'koek', 'snoep', 'fruitgum', 'tic-tac', 'pringles', 'paasei', 'paas', 'koffiebonen', 'olijfolie', 'wijn', 'prosecco', 'sap', 'smoothie', 'energy-drink', 'water-', 'americano', 'espresso'] },
  { categories: ['glaswerk-drinkflessen', 'drinkwaren', 'relatiegeschenken'], categoriesMatch: ['drinkingbottles', 'drinking-cups', 'drinkware', 'shot-glasses'], slugIncludes: ['beker', 'bekers', 'drinkfles', 'waterfles', 'thermosfles', 'vacuumfles', 'theefles', 'fles', 'flessen', 'bidon', 'tumbler', 'glas', 'glazen', 'mok', 'thermos', 'karaf'] },
  { categories: ['mokken', 'drinkwaren', 'relatiegeschenken'], slugIncludes: ['mok', 'mokken'] },
  { categories: ['kantoor-promotie', 'relatiegeschenken'], categoriesMatch: ['office-stationery', 'office-print'], slugIncludes: ['klembord', 'bureau', 'notitieboekje', 'memoblok', 'stempel', 'colop', 'trodat', 'kaarthouder'] },
  { categories: ['stempels', 'kantoor-promotie'], slugIncludes: ['stempel', 'colop', 'trodat'] },
  { categories: ['usb-powerbanks', 'technologie', 'relatiegeschenken'], categoriesMatch: ['usb-sticks'], slugIncludes: ['usb', 'powerbank', 'speaker', 'draadloos'] },
  { categories: ['polsbandjes-event', 'beurs-evenement'], categoriesMatch: ['wristbands'], slugIncludes: ['polsbandje'] },
  { categories: ['horeca-menu', 'paper-print'], categoriesMatch: ['horeca-print', 'napkins'], slugIncludes: ['menu', 'biervilt', 'placemat', 'servet', 'bestek', 'tafelkaart', 'tentkaart'] },
  { categories: ['posters', 'paper-print'], categoriesMatch: ['posters'], slugIncludes: ['poster', 'posters'] },
  { categories: ['fotoprints', 'wanddecoratie'], categoriesMatch: ['fotoprints'], slugIncludes: ['fotoprint'] },
  { categories: ['ingelijste-prints', 'wanddecoratie'], slugIncludes: ['lijst', 'fotolijst', 'ingelijst', 'ingelijste'] },
  { categories: ['plexiglas-acryl', 'wanddecoratie'], slugIncludes: ['plexiglas', 'acryl'] },
  { categories: ['aluminium-dibond', 'wanddecoratie', 'plaatmateriaal'], slugIncludes: ['aluminium-bord', 'aluminium-paneel', 'aluminium-fotopaneel', 'foto-op-aluminium', 'aluminium-print', 'aluminium-composiet', 'dibond'] },
  { categories: ['fototegels', 'keuken-interieur', 'wanddecoratie'], slugIncludes: ['tegel'] },
  { categories: ['keuken-interieur', 'indoor-interior', 'home-living'], slugIncludes: ['inductiebeschermer', 'inductie-beschermer', 'keukenprint', 'spatwand'] },
  { categories: ['wanddecoratie'], slugIncludes: ['wandcirkel', 'wandcirkels', 'fotopaneel', 'fotopanelen'] },
  { categories: ['akoestiek', 'indoor-interior'], slugIncludes: ['akoestisch', 'acoustic', 'pet-vilt'] },
  { categories: ['behang-wandbekleding', 'indoor-interior'], categoriesMatch: ['behang'], slugIncludes: ['behang', 'wall-finish'] },
  { categories: ['deurmatten', 'floor-decoration', 'indoor-interior'], slugIncludes: ['deurmat'] },
  { categories: ['vloerbescherming', 'floor-decoration'], slugIncludes: ['vloerbeschermer', 'vloervinyl', 'tapijtvloer'] },
  { categories: ['vinylstickers', 'stickers-tapes'], categoriesMatch: ['loose-stickers'], slugIncludes: ['vinylsticker', 'autosticker', 'doming-sticker'] },
  { categories: ['muurstickers', 'stickers-tapes', 'indoor-interior'], slugIncludes: ['muursticker'] },
  { categories: ['stickers-folies', 'stickers-tapes'], slugIncludes: ['raamsticker', 'vloersticker', 'snijfolie', 'carwrap', 'folie', 'magneet'] },
  { categories: ['labels-etiketten', 'stickers-tapes', 'verpakkingen'], slugIncludes: ['etiket', 'label', 'stickervel', 'stickers-op-rol'] },
  { categories: ['spandoeken-banners', 'outdoor-advertising'], slugIncludes: ['spandoek', 'spandoeken', 'banner', 'banners', 'hekwerkbanner', 'bouwhekdoek', 'dranghekdoek', 'textieldoek'] },
  { categories: ['stoepborden', 'displays-pos'], slugIncludes: ['stoepbord', 'a-bord'] },
  { categories: ['lichtreclame', 'outdoor-advertising'], slugIncludes: ['lichtbak', 'led-frame', 'led-kliklijst', 'lichtbakposter'] },
  { categories: ['bewegwijzering-borden', 'outdoor-advertising'], slugIncludes: ['bewegwijzer', 'reclamebord', 'gevelbord', 'naambord', 'makelaarsbord', 'verkiezingsbord', 'rallyschild', 'v-bord'] },
  { categories: ['tuinposters', 'outdoor-advertising'], categoriesMatch: ['outdoor-living'], slugIncludes: ['tuinposter'] },
  { categories: ['roll-up-banners', 'beurs-evenement', 'displays-pos'], categoriesMatch: ['reclame'], slugIncludes: ['roll-up', 'rollup', 'segrollr'] },
  { categories: ['beurswanden', 'beurs-evenement'], slugIncludes: ['beursstand', 'presentatiewand', 'achterwand', 'zipper-wand', 'pop-up-presentatiewand'] },
  { categories: ['festival-eventdoeken', 'beurs-evenement'], slugIncludes: ['festival', 'eventdoek', 'vlaggenlijn'] },
  { categories: ['beachflags', 'vlaggen'], slugIncludes: ['beachflag'] },
  { categories: ['vlaggen', 'outdoor-advertising'], slugIncludes: ['tafelvlag', 'tafelvlaggen', 'raamvlag', 'vlaggenlijn', 'vlaggenlijnen'] },
  { categories: ['gevelvlaggen', 'vlaggen', 'gevel-voertuig'], slugIncludes: ['gevelvlag', 'gevelbanier', 'kioskvlag'] },
  { categories: ['mastvlaggen', 'vlaggen'], categoriesMatch: ['flags'], slugIncludes: ['mastvlag', 'baniervlag', 'vlaggenmast', 'vlaggenstok', 'zwaaivlag'] },
  { categories: ['plaat-forex', 'plaatmateriaal'], slugIncludes: ['forex', 'pvc', 'kunststof'] },
  { categories: ['plaat-dibond', 'plaatmateriaal'], slugIncludes: ['dibond'] },
  { categories: ['plaat-karton-board', 'plaatmateriaal'], slugIncludes: ['displaykarton', 'foamboard', 'kanaalplaat', 're-board', 'golfkarton'] },
  { categories: ['materiaal-samples', 'plaatmateriaal'], categoriesMatch: ['materials-samples'], slugIncludes: ['sample', 'lookbook', 'waaier'] },
  { categories: ['bannermaterialen', 'textielframes-doeken'], slugIncludes: ['frontlit', 'mesh-banner', 'blockout', 'banner'] },
  { categories: ['textielmaterialen', 'textielframes-doeken'], slugIncludes: ['decotex', 'blackback', 'backlit', 'spunpolyester', 'flag-pet', 'textiel'] },
  { categories: ['flyers', 'paper-print'], slugIncludes: ['flyer'] },
  { categories: ['folders-brochures', 'paper-print'], slugIncludes: ['folder', 'brochure', 'magazine'] },
  { categories: ['visitekaartjes', 'paper-print'], slugIncludes: ['visitekaart'] },
  { categories: ['kaarten', 'paper-print'], categoriesMatch: ['kaarten', 'postcards'], slugIncludes: ['kaart', 'cards'] },
  { categories: ['briefpapier-enveloppen', 'paper-print'], slugIncludes: ['briefpapier', 'envelop'] },
  { categories: ['bouwtekeningen', 'paper-print'], slugIncludes: ['bouwtekening', 'plattegrond'] },
  { categories: ['presentatiemappen', 'paper-print'], slugIncludes: ['presentatiemap'] },
  { categories: ['kalenders', 'paper-print'], slugIncludes: ['kalender', 'agenda'] },
  { categories: ['notitieboeken', 'paper-print'], categoriesMatch: ['notebooks'], slugIncludes: ['notitieboek', 'notitieblok'] },
  { categories: ['fotoboeken', 'boeken-magazines'], slugIncludes: ['fotoboek', 'hardcover-boek', 'softcover-boek'] },
  { categories: ['verzendverpakkingen', 'verpakkingen'], categoriesMatch: ['shipping-packaging'], slugIncludes: ['verzend', 'verzenddoos', 'verzenddozen', 'brievenbusdoos', 'brievenbusdozen', 'luchtkussen', 'mail'] },
  { categories: ['dozen-verpakkingen', 'verpakkingen'], categoriesMatch: ['gift-packaging'], slugIncludes: ['doos', 'dozen', 'bonbondoos', 'kubusdoos', 'verpakkingsdoos', 'box', 'gondel', 'gondeldoos', 'telescoopdoos', 'schuifdoos'] },
  { categories: ['tassen-verpakkingen', 'verpakkingen', 'tassen'], categoriesMatch: ['packaging-bags', 'promotional-bags'], slugIncludes: ['tas', 'tassen', 'shopper', 'rugzak', 'gymtas', 'wijntas'] },
  { categories: ['horeca-verpakkingen', 'verpakkingen'], slugIncludes: ['foodbox', 'snack', 'patat', 'pizza', 'poke', 'ijsbeker', 'koffiebeker', 'beker'] },
  { categories: ['tape-lint', 'verpakkingen'], slugIncludes: ['tape', 'lint'] },
  { categories: ['kussens', 'home-living'], slugIncludes: ['kussen'] },
  { categories: ['dekens-handdoeken', 'textiel-cadeaus'], slugIncludes: ['deken', 'handdoek', 'badlaken', 'strandlaken', 'washand'] },
  { categories: ['tassen', 'textiel-cadeaus'], slugIncludes: ['tote', 'draagtas'] },
  // Een hanger of promotieartikel is niet automatisch een fotocadeau.
  // Beoordeelde fotoproducten staan expliciet in product-category-decisions.json.
  { categories: ['foto-cadeaus', 'relatiegeschenken'], slugIncludes: ['puzzel', 'fotopuzzel', 'foto-hanger', 'fotoblok'] },
  { categories: ['dames-kleding', 'kleding'], slugIncludes: ['dames', 'women', 'womens', 'women-s', 'vrouw'] },
  { categories: ['heren-kleding', 'kleding'], slugIncludes: ['heren', 'men', 'mens', 'men-s'] },
  { categories: ['unisex-kleding', 'kleding'], slugIncludes: ['unisex'] },
  { categories: ['sportkleding', 'kleding'], slugIncludes: ['sport', 'sports', 'athletic', 'yoga', 'jersey', 'rashguard', 'rash-guard', 'sport-bh', 'training', 'hockey', 'basketball', 'basketbal'] },
  { categories: ['zwemkleding', 'kleding'], slugIncludes: ['zwem', 'swim', 'bikini', 'badpak', 'rashguard', 'rash-guard', 'trunks'] },
  { categories: ['leggings-shorts', 'kleding'], slugIncludes: ['legging', 'leggings', 'shorts', 'joggingbroek', 'joggers', 'pants', 'broek'] },
  { categories: ['all-over-kleding', 'kleding'], slugIncludes: ['all-over', 'aop', 'cut-sew'] },
  { categories: ['shirts-tops', 'kleding'], slugStartsWith: ['t-shirt', 'tanktop', 'sportshirt'] },
  { categories: ['shirts-tops', 'kleding'], slugIncludes: ['t-shirt', 'shirt', 'tanktop', 'crop-top', 'crop-tee'] },
  { categories: ['hoodies-sweaters', 'kleding'], categoriesMatch: ['hoodies'], slugStartsWith: ['hoodie', 'sweater'] },
  { categories: ['kinder-baby-kleding', 'kleding'], slugIncludes: ['kinder', 'baby', 'romper', 'slabbetje'] },
  { categories: ['werkkleding-horeca', 'kleding'], categoriesMatch: ['aprons'], slugIncludes: ['schort', 'sloof'], slugStartsWith: ['polo', 'schort', 'sloof'] },
  { categories: ['caps-mutsen', 'kleding'], categoriesMatch: ['hats'], slugIncludes: ['pet', 'cap', 'muts', 'bucket', 'zonneklep'] },
  { categories: ['telefoonhoesjes', 'technologie'], slugIncludes: ['telefoonhoes', 'phone-case'] },
  { categories: ['muismatten-gaming', 'technologie'], slugIncludes: ['muismat', 'gaming'] },
  { categories: ['laptop-tablet-accessoires', 'technologie'], slugIncludes: ['laptop', 'tablet', 'ipad'] },
  { categories: ['ophangsystemen', 'accessoires'], slugIncludes: ['ophang', 'muurbeugel', 'plafond-magneet', 'posterhouder'] },
  { categories: ['afstandhouders', 'accessoires'], slugIncludes: ['afstandhouder', 'zijgrip'] },
  { categories: ['banner-accessoires', 'accessoires'], categoriesMatch: ['banner-frames', 'accessories-sign', 'signs-banners'], slugIncludes: ['spanner', 'tiewrap', 'karabijnhaak', 'zuignap', 'rotator', 'grondboor', 'grondpen', 'voetplaat', 'waterzak', 'frame-spandoek'] },
  { categories: ['standaards-houders', 'accessoires'], slugIncludes: ['standaard', 'houder', 'folderdisplay', 'infokader', 'kliklijst'] },
  { categories: ['outdoor-meubilair', 'outdoor-advertising'], categoriesMatch: ['outdoor-furniture'], slugIncludes: ['strandstoel', 'regisseursstoel', 'hangmat', 'parasol'] },
  { categories: ['sport-promotie', 'sport-spel'], slugIncludes: ['sport', 'traininghesje', 'veiligheidshesje', 'bidon'] },
  { categories: ['spellen-puzzels', 'sport-spel'], slugIncludes: ['spel', 'puzzel', 'speelkaarten', 'kwartet', 'memory', 'frisbee'] },
];

function uniqueCategoryValues(values: string[]) {
  return Array.from(new Set(values.map((value) => getCanonicalConsumerCategory(value))));
}

function slugMatchesRule(slug: string, rule: (typeof categoryRuleAssignments)[number]) {
  const normalizedSlug = slug.trim().toLowerCase();
  if (!normalizedSlug) return false;
  const tokens = normalizedSlug.split('-').filter(Boolean);
  const termVariants = (value: string) => Array.from(new Set([
    value,
    `${value}s`,
    `${value}en`,
    ...(value.endsWith('e') ? [`${value}n`] : []),
  ]));
  const includesTerm = (rawValue: string) => {
    const value = rawValue.toLowerCase().replace(/^-|-$/g, '');
    if (!value) return false;
    if (!value.includes('-')) return tokens.some((token) => termVariants(value).includes(token));
    return normalizedSlug === value || normalizedSlug.startsWith(`${value}-`) ||
      normalizedSlug.endsWith(`-${value}`) || normalizedSlug.includes(`-${value}-`);
  };

  return Boolean(
    rule.slugStartsWith?.some((value) => normalizedSlug.startsWith(value.toLowerCase())) ||
    rule.slugIncludes?.some(includesTerm)
  );
}

function getPrismaSlugRuleFilters(rule: (typeof categoryRuleAssignments)[number]) {
  return [
    ...(rule.slugIncludes?.flatMap((rawValue) => {
      const value = rawValue.toLowerCase().replace(/^-|-$/g, '');
      const variants = Array.from(new Set([value, `${value}s`, `${value}en`, ...(value.endsWith('e') ? [`${value}n`] : [])]));
      return variants.flatMap((variant) => [
        { slug: { equals: variant, mode: 'insensitive' as const } },
        { slug: { startsWith: `${variant}-`, mode: 'insensitive' as const } },
        { slug: { endsWith: `-${variant}`, mode: 'insensitive' as const } },
        { slug: { contains: `-${variant}-`, mode: 'insensitive' as const } },
      ]);
    }) || []),
    ...(rule.slugStartsWith?.map((value) => ({ slug: { startsWith: value, mode: 'insensitive' as const } })) || []),
  ];
}

function getRuleCategories(slug: string, category: string | null | undefined) {
  const normalizedCategory = (category || '').toLowerCase();

  return categoryRuleAssignments.flatMap((rule) => {
    const categoryMatches = rule.categoriesMatch?.some((value) => normalizedCategory === value.toLowerCase()) || false;
    const slugMatches = slugMatchesRule(slug, rule);

    return categoryMatches || slugMatches ? rule.categories : [];
  });
}

/**
 * Een product in een subcategorie hoort ook in alle bovenliggende categorieën.
 * Zo verschijnt een fototegel bijvoorbeeld automatisch bij Fototegels,
 * Wanddecoratie én Foto & wand, zonder dezelfde relatie overal te herhalen.
 */
function withCategoryAncestors(categories: string[]) {
  const result = new Set<string>();

  for (const value of uniqueCategoryValues(categories)) {
    let current: string | undefined = value;
    const visited = new Set<string>();
    while (current && !visited.has(current)) {
      visited.add(current);
      result.add(current);
      current = getCategoryDefinition(current)?.parentSlug;
    }
  }

  return Array.from(result);
}

function getAssignedProductSlugsForCategory(category: string) {
  const canonical = getCanonicalConsumerCategory(category);
  const explicitAssignments: Record<string, string[]> = {
    ...productCategoryAssignments,
    ...(productCategoryDecisions as Record<string, string[]>),
  };

  return Object.entries(explicitAssignments)
    .filter(([, categories]) => withCategoryAncestors(categories).includes(canonical))
    .map(([slug]) => slug);
}

export type ProductCategoryOverrides = {
  additions?: string[];
  exclusions?: string[];
};

export function getProductCategoryOverrides(specifications: unknown): ProductCategoryOverrides {
  if (!specifications || typeof specifications !== 'object' || Array.isArray(specifications)) return {};
  const values = specifications as Record<string, unknown>;
  const read = (key: string) => Array.isArray(values[key])
    ? uniqueCategoryValues((values[key] as unknown[]).filter((value): value is string => typeof value === 'string'))
    : [];

  return {
    additions: read('storefrontCategoryAdditions'),
    exclusions: read('storefrontCategoryExclusions'),
  };
}

export function getProductCategorySlugs(
  slug: string,
  category: string | null | undefined,
  overrides: ProductCategoryOverrides = {},
) {
  const reviewedCategories = (productCategoryDecisions as Record<string, string[]>)[slug];
  if (reviewedCategories) {
    const excluded = new Set(uniqueCategoryValues(overrides.exclusions || []));
    return withCategoryAncestors([...reviewedCategories, ...(overrides.additions || [])])
      .filter((value) => !excluded.has(value));
  }
  const directCategory = category && getCategoryDefinition(category) ? [category] : [];
  const inferredCategories = [
    ...(productCategoryAssignments[slug] || []),
    ...getRuleCategories(slug, category),
  ];

  const excluded = new Set(uniqueCategoryValues(overrides.exclusions || []));
  return withCategoryAncestors([
    ...directCategory,
    ...inferredCategories,
    ...(directCategory.length === 0 && inferredCategories.length === 0 && category ? [category] : []),
    ...(overrides.additions || []),
  ]).filter((value) => !excluded.has(value));
}

/**
 * Een product zonder handmatige categoriebeoordeling krijgt zijn categorie uit
 * het veld `category` (getProductCategorySlugs, dus breadcrumb en tellingen),
 * maar de categoriepagina filtert in de database alleen op vaste lijsten en
 * `storefrontCategoryAdditions` (getConsumerCategoryWhere). Een filter op het
 * veld zelf kan niet: 398 beoordeelde producten hebben daar een andere waarde
 * staan dan hun beoordeling, en een notIn op 1287 slugs is te groot.
 *
 * Daarom zetten we bij zo'n product de eigen categorie expliciet in
 * storefrontCategoryAdditions. Geeft de nieuwe specificaties terug, of null als
 * er niets hoeft te veranderen.
 */
export function ensureOwnCategoryListed(
  slug: string,
  category: string | null | undefined,
  specifications: unknown,
): Record<string, any> | null {
  if (!slug || !category || !getCategoryDefinition(category)) return null;
  if (Object.prototype.hasOwnProperty.call(productCategoryDecisions, slug)) return null;
  const canonical = getCanonicalConsumerCategory(category);
  // Alleen een echte categorienaam, geen brede leveranciersalias (General).
  if (canonical !== category) return null;
  if ((productCategoryAssignments[slug] || []).some((value) => withCategoryAncestors([value]).includes(canonical))) return null;
  const specs = specifications && typeof specifications === 'object' && !Array.isArray(specifications)
    ? { ...(specifications as Record<string, any>) }
    : {};
  const overrides = getProductCategoryOverrides(specs);
  if ((overrides.additions || []).includes(canonical) || (overrides.exclusions || []).includes(canonical)) return null;
  specs.storefrontCategoryAdditions = [...(overrides.additions || []), canonical];
  return specs;
}

export function getPrimaryProductCategory(categories: string[], fallback: string) {
  const depth = (category: string) => {
    let current = getCategoryDefinition(category);
    let value = 0;
    const visited = new Set<string>();
    while (current?.parentSlug && !visited.has(current.slug)) {
      visited.add(current.slug);
      value += 1;
      current = getCategoryDefinition(current.parentSlug);
    }
    return value;
  };
  return [...categories].sort((left, right) => depth(right) - depth(left))[0] || fallback;
}

export function consumerProductWhere() {
  const ruleCategoryValues = Array.from(new Set(categoryRuleAssignments.flatMap((rule) => rule.categoriesMatch || [])));
  const slugRuleFilters = categoryRuleAssignments.flatMap(getPrismaSlugRuleFilters);

  return {
    OR: [
      { slug: { in: [...consumerProductSlugs] } },
      { slug: { in: Object.keys(productCategoryAssignments) } },
      { slug: { in: Object.keys(productCategoryDecisions as Record<string, string[]>) } },
      { category: { in: getAllCategoryFilterValues() } },
      ...(ruleCategoryValues.length > 0 ? [{ category: { in: ruleCategoryValues } }] : []),
      ...slugRuleFilters,
    ],
  };
}

type ConsumerProductMatcher = {
  slugs: Set<string>;
  categories: Set<string>;
  /** Kleine letters, al met de s/en/n-varianten zoals getPrismaSlugRuleFilters ze maakt. */
  slugTerms: string[];
  slugPrefixes: string[];
};

let consumerProductMatcher: ConsumerProductMatcher | null = null;

function getConsumerProductMatcher(): ConsumerProductMatcher {
  if (consumerProductMatcher) return consumerProductMatcher;
  const terms = new Set<string>();
  const prefixes = new Set<string>();
  for (const rule of categoryRuleAssignments) {
    for (const rawValue of rule.slugIncludes || []) {
      const value = rawValue.toLowerCase().replace(/^-|-$/g, '');
      [value, `${value}s`, `${value}en`, ...(value.endsWith('e') ? [`${value}n`] : [])].forEach((variant) => terms.add(variant));
    }
    for (const value of rule.slugStartsWith || []) prefixes.add(value.toLowerCase());
  }
  consumerProductMatcher = {
    slugs: new Set<string>([
      ...consumerProductSlugs,
      ...Object.keys(productCategoryAssignments),
      ...Object.keys(productCategoryDecisions as Record<string, string[]>),
    ]),
    categories: new Set<string>([
      ...getAllCategoryFilterValues(),
      ...categoryRuleAssignments.flatMap((rule) => rule.categoriesMatch || []),
    ]),
    slugTerms: Array.from(terms),
    slugPrefixes: Array.from(prefixes),
  };
  return consumerProductMatcher;
}

/**
 * Doet in het geheugen precies wat consumerProductWhere() in de database doet:
 * slug- en categorielijsten exact (hoofdlettergevoelig, zoals Prisma's `in`),
 * slugregels zonder hoofdlettergevoeligheid (Prisma `mode: 'insensitive'`),
 * zonder trim. isConsumerProduct gebruikt dezelfde functie. De
 * gelijkwaardigheid met het Prisma-filter staat vast in
 * consumer-product-matcher.test.ts.
 */
export function matchesConsumerProductWhere(product: { slug: string; category: string | null | undefined }) {
  const matcher = getConsumerProductMatcher();
  if (matcher.slugs.has(product.slug)) return true;
  if (product.category != null && matcher.categories.has(product.category)) return true;
  const slug = product.slug.toLowerCase();
  for (const term of matcher.slugTerms) {
    if (slug === term || slug.startsWith(`${term}-`) || slug.endsWith(`-${term}`) || slug.includes(`-${term}-`)) return true;
  }
  return matcher.slugPrefixes.some((prefix) => slug.startsWith(prefix));
}

/**
 * Hoort dit product in de winkel? Zelfde antwoord als het databasefilter
 * (consumerProductWhere), zodat productpagina en overzichten nooit verschillen.
 * Supplier-categorieën tellen dus hoofdlettergevoelig (`Reclame` is niet
 * `reclame`) en samengestelde termen krijgen meervoudsvarianten (roll-ups-*).
 */
export function isConsumerProduct(slug: string, category?: string | null) {
  return matchesConsumerProductWhere({ slug, category });
}

/**
 * De regel van isConsumerProduct van vóór 17-10-2026: categoriesMatch zonder
 * hoofdletters, slugregels na trim en zonder meervouden van samengestelde
 * termen. Alleen nog nodig zodat geen productpagina die toen bereikbaar was nu
 * een 404 geeft (Google, links van klanten).
 */
function matchesLegacyConsumerProductPage(slug: string, category?: string | null) {
  if (consumerProductSlugs.includes(slug as typeof consumerProductSlugs[number])) return true;

  const normalizedCategory = category || '';
  if (normalizedCategory && getAllCategoryFilterValues().includes(normalizedCategory)) return true;
  if (Object.prototype.hasOwnProperty.call(productCategoryAssignments, slug)) return true;
  if (Object.prototype.hasOwnProperty.call(productCategoryDecisions, slug)) return true;

  const lowerCategory = normalizedCategory.toLowerCase();
  return categoryRuleAssignments.some((rule) =>
    rule.categoriesMatch?.some((value) => value.toLowerCase() === lowerCategory) || slugMatchesRule(slug, rule)
  );
}

/**
 * Mag de productpagina dit product tonen? Alles wat in de overzichten staat
 * (isConsumerProduct), plus wat de pagina vroeger al toonde. Overzichten,
 * zoeken en sitemap volgen alleen isConsumerProduct.
 */
export function isConsumerProductPageVisible(slug: string, category?: string | null) {
  return isConsumerProduct(slug, category) || matchesLegacyConsumerProductPage(slug, category);
}

export function formatConsumerCategory(category: string, locale = 'nl') {
  return formatCategory(category, locale);
}

export function getCanonicalConsumerCategory(category: string) {
  return getCanonicalCategory(category);
}

export function getConsumerCategoryFilterValues(category: string) {
  return getCategoryTreeFilterValues(category);
}

export type CategoryOverrideIndex = {
  /** categorie -> product-id's met die categorie in storefrontCategoryAdditions */
  additions: Record<string, string[]>;
  /** categorie -> product-id's met die categorie in storefrontCategoryExclusions */
  exclusions: Record<string, string[]>;
};

export const EMPTY_CATEGORY_OVERRIDE_INDEX: CategoryOverrideIndex = { additions: {}, exclusions: {} };

/**
 * Filter voor een winkelcategorie. Met `overrides` (zie
 * category-override-index.server.ts) filtert dit op product-id; zonder valt
 * het terug op een JSON-pad in de specificaties. Dat laatste laat Postgres van
 * elk product de volledige specificaties uitpakken en is daarom alleen voor
 * plekken zonder index bedoeld.
 */
export function getConsumerCategoryWhere(category: string, overrides?: CategoryOverrideIndex) {
  const assignedSlugs = getAssignedProductSlugsForCategory(category);
  const canonical = getCanonicalConsumerCategory(category);

  if (overrides) {
    const addedIds = overrides.additions[canonical] || [];
    const excludedIds = overrides.exclusions[canonical] || [];
    return {
      AND: [
        {
          OR: [
            ...(assignedSlugs.length > 0 ? [{ slug: { in: assignedSlugs } }] : []),
            ...(addedIds.length > 0 ? [{ id: { in: addedIds } }] : []),
            // Lege OR matcht in Prisma niets; dit houdt de categorie dan expliciet leeg.
            ...(assignedSlugs.length === 0 && addedIds.length === 0 ? [{ id: { in: [] as string[] } }] : []),
          ],
        },
        ...(excludedIds.length > 0 ? [{ id: { notIn: excludedIds } }] : []),
      ],
    };
  }

  return {
    AND: [
      {
        OR: [
          ...(assignedSlugs.length > 0 ? [{ slug: { in: assignedSlugs } }] : []),
          { specifications: { path: ['storefrontCategoryAdditions'], array_contains: [canonical] } },
        ],
      },
      {
        // PostgreSQL geeft NULL terug wanneer het JSON-pad niet bestaat. Alleen
        // `NOT array_contains` zou daardoor ook alle producten zonder een
        // exclusions-veld wegfilteren. AnyNull houdt die gewone producten in
        // beeld en sluit uitsluitend een expliciet uitgesloten categorie uit.
        OR: [
          {
            specifications: {
              path: ['storefrontCategoryExclusions'],
              equals: Prisma.AnyNull,
            },
          },
          {
            NOT: {
              specifications: { path: ['storefrontCategoryExclusions'], array_contains: [canonical] },
            },
          },
        ],
      },
    ],
  };
}

export function getConsumerCategoryOptions(products: Array<{ slug?: string | null; category: string | null; specifications?: unknown; count?: number }>, locale = 'nl') {
  const categoryMap = new Map<string, { value: string; label: string; count: number }>();

  products.forEach((item) => {
    getProductCategorySlugs(item.slug || '', item.category, getProductCategoryOverrides(item.specifications)).forEach((value) => {
      const existing = categoryMap.get(value);

      if (existing) {
        existing.count += item.count || 1;
        return;
      }

      categoryMap.set(value, {
        value,
        label: formatConsumerCategory(value, locale),
        count: item.count || 1,
      });
    });
  });

  return Array.from(categoryMap.values()).sort((a, b) => a.label.localeCompare(b.label, locale));
}

export function getSafeStorefrontImage(image?: string | null) {
  if (!image) return null;

  try {
    const url = new URL(image);
    if (url.hostname === 'bestelprint.nl' || url.hostname === 'www.bestelprint.nl') return null;
    if (url.hostname === 'images.unsplash.com') return null;
  } catch {
    return image;
  }

  return image;
}

export function getProductFallbackImage(slug: string, category?: string | null) {
  if (slug === 'fototegel') return '/images/products/mockup-photo-gift.svg';
  if (slug === 'foto-op-poster') return '/images/products/mockup-foto-op-poster.svg';
  if (slug === 'behangcirkel') return '/images/products/mockup-behangcirkel.svg';
  if (slug === 'tuinposter') return '/images/products/mockup-tuinposter.svg';
  if (slug === 'vinylsticker') return '/images/products/mockup-vinylsticker.svg';
  if (slug === 'muursticker') return '/images/products/mockup-muursticker.svg';
  if (slug === 'spandoek') return '/images/products/mockup-spandoek.svg';
  if (slug === 'folder') return '/images/products/mockup-folder.svg';
  if (slug === 'bouwtekening') return '/images/products/mockup-bouwtekening.svg';
  if (slug.includes('ophang') || slug.includes('posterklem') || slug.includes('spanner') || slug.includes('tiewrap') || slug.includes('haak') || category === 'accessories-posters' || category === 'accessoires') return '/images/products/mockup-accessory.svg';
  if (slug.includes('canvas') || category === 'canvas') return '/images/products/mockup-canvas.svg';
  if (slug.includes('spandoek') || slug.includes('banner') || slug.includes('vlag') || slug.includes('flag')) return '/images/products/mockup-spandoek.svg';
  if (
    slug.includes('poster') ||
    category === 'posters' ||
    category === 'outdoor-advertising' ||
    category === 'vlaggen' ||
    category === 'beurs-evenement' ||
    category === 'displays-pos' ||
    category === 'binnenreclame' ||
    category === 'gevel-voertuig' ||
    category === 'plaatmateriaal' ||
    category === 'textielframes-doeken'
  ) return '/images/products/mockup-poster.svg';
  if (slug.includes('behang') || category === 'indoor-interior' || category === 'home-living') return '/images/products/mockup-wallart.svg';
  if (slug.includes('sticker') || category === 'stickers-tapes') return '/images/products/mockup-photo-gift.svg';
  if (category === 'paper-print' || category === 'verpakkingen' || category === 'notitieboeken') return '/images/products/mockup-poster.svg';
  if (slug.includes('fotoboek') || category === 'fotoboeken' || category === 'boeken-magazines') return '/images/products/mockup-photobook.svg';
  if (slug.includes('mok') || category === 'mokken') return '/images/products/mockup-mug.svg';
  if (slug.includes('telefoon') || slug.includes('phone') || category === 'technologie') return '/images/products/mockup-phonecase.svg';
  if (slug.includes('tote') || category === 'textiel-cadeaus' || category === 'kleding') return '/images/products/mockup-totebag.svg';
  if (slug.includes('kalender') || category === 'kalenders') return '/images/products/mockup-calendar.svg';
  if (category === 'wanddecoratie') return '/images/products/mockup-wallart.svg';
  return '/images/products/mockup-photo-gift.svg';
}

export function getSafeProductImage(slug: string, category?: string | null, image?: string | null) {
  return getSafeStorefrontImage(image) || getProductFallbackImage(slug, category);
}

export function getSafeProductImages(slug: string, category?: string | null, images: string[] = [], thumbnail?: string | null) {
  const safeImages = [thumbnail, ...images]
    .map((image) => getSafeStorefrontImage(image))
    .filter((image): image is string => Boolean(image));

  return safeImages.length > 0 ? Array.from(new Set(safeImages)) : [getProductFallbackImage(slug, category)];
}
